


















































import { PublishmentOrder } from "@/interfaces/publishmentorder";
import Vue, { PropType } from "vue";
export default Vue.extend({
  props: {
    publishmentOrder: Object as PropType<PublishmentOrder>
  },
  data() {
    return {
      active: false,
      req: {
        publishesAt: null as Date | null,
        note: ""
      }
    };
  },
  watch: {
    active(newValue: boolean) {
      if (newValue && this.publishmentOrder) {
        this.req.publishesAt = new Date(this.publishmentOrder.publishesAt);
      }
    }
  },
  methods: {
    click() {
      this.active = true;
    },
    async exec(cb: () => void) {
      if (!this.publishmentOrder) {
        return;
      }
      await this.$store.dispatch("patch", [
        this.publishmentOrder["@id"] + "/confirm",
        this.req
      ]);
      this.$emit("success");
      cb();
    }
  }
});
